import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'editQuestsSearch',
  pure: false

})
export class EditQuestsSearchPipe implements PipeTransform {

  transform(data, searchTerm: string): any[] {
    if (searchTerm) {
      searchTerm = searchTerm.toLowerCase();
      return data.filter(item => {
          if (item.guestName.toLowerCase().indexOf(searchTerm) !== -1 ||
            item.guestEmail.toLowerCase().indexOf(searchTerm) !== -1) {
            return true;
          } else {
            let foundMembersGuest = false;
            if (item.guests) {
              for (let i = 0; i < item.guests.length; i++) {
                if (item.guests[i].guestName.toLowerCase().indexOf(searchTerm) !== -1 ||
                  item.guests[i].guestEmail.toLowerCase().indexOf(searchTerm) !== -1) {
                  foundMembersGuest = true;
                  break;
                }
              }
            }

            if (foundMembersGuest) {
              item.expanded = true;
              return true;
            } else {
              item.expanded = false;
              return false;
            }
          }
        }
      );
    } else {
      return data;
    }
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/edit-guests/edit-quests-search.pipe.ts